import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import get from "lodash/get";
import React, { Component } from "react";
import { instance } from "../../../../../../Actions/AxiosInstance";
import SectionHeaderExtraSmall from "../../../../../../Component/Headers/sectionHeaderExtraSmall";
import emptySearch from "../../../../../../Assets/Svg/payroll-component-empty.svg";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { radioinputconverter } from "../../../../../../Component/DynamicForm/Fields/Radio";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";
import { textinputconverter } from "../../../../../../Component/DynamicForm/Fields/Text";
import DrawerHeader from "../../../../../../Component/Headers/drawerHeader";
import { ErrorMessages } from "../../../../../../Constants";
import { checkboxinputconverter } from "../../../../../../Component/DynamicForm/Fields/CheckBox";
import TextField from "@material-ui/core/TextField";


export default class SalaryComponentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postdata: POSTDATA,
      searchdata: [],
      selectedSearch: null,
      allmastertaxgroup: [],
      issimplecomponentchecked: false,
      originalpostdata: POSTDATA,
      datareceived: false,
    };
    this.getSalaryComponent = this.getSalaryComponent.bind(this);
    this.getallmastertaxgroup = this.getallmastertaxgroup.bind(this);
    this.setpostdata = this.setpostdata.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    const { selectedsalarycomponent } = this.props;
    this.getallmastertaxgroup();
    selectedsalarycomponent
      ? this.getSalaryComponent(selectedsalarycomponent)
      : this.setState({ datareceived: true });
  }

  getallmastertaxgroup() {
    const mastertaxgroupid = 1;
    instance
      .get(`payroll/getallmastertaxgroup/${mastertaxgroupid}`)
      .then((resp) => {
        this.setState({ allmastertaxgroup: get(resp, "data.result", []) });
      });
  }

  getSalaryComponent(componentdetails) {
    // instance
    //   .get(
    //     `payroll/getallsalarycomponent/${componentdetails.salarycomponentid ||
    //       componentdetails.displayvalue}`,
    //   )
    instance
      .post("payroll/getallsalarycomponent", {
        salarycomponentid: componentdetails.displayvalue,
      })
      .then((res) => {
        const DATA = {
          ...get(res, "data.result[0]", {}),
          salarycomponentid: get(res, "data.result[0].displayvalue", ""),
          componentname: get(res, "data.result[0].displayname", ""),
        };
        this.setState({
          postdata: DATA,
          datareceived: true,
          issimplecomponentchecked: DATA.mastercomponentid,
          originalpostdata: DATA,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  // checkname = (val) => {
  //   instance.post("payroll/uniquecomponentname", { salarycomponentid: null, componentname: val });
  //   this.setpostdata("componentname", val);
  // };

  setpostdata(key, value) {
    console.log("key, value: ", key, value);
    this.setState({
      postdata: {
        ...this.state.postdata,
        [key]: value,
      },
    });
  }

  isvalid = ({
    // salarycomponentid,
    componentname,
    // mastercomponentid,
    // issimplecomponent,
    // journalvoucher,
    componenttypeid,
    // isemployeededuction,
    paidastypeid,
    istaxfree,
    mastertaxgroupid,
    isaccrual,
    isstatutory,
    statutorytypeid,
  }) =>
    componentname
    && componenttypeid
    && paidastypeid
    // && isemployeededuction !== null
    && (componenttypeid == 1 || componenttypeid == 2 ? istaxfree != null && istaxfree == false ? !mastertaxgroupid ? false : true : true : true)
    && isaccrual !== null
    && isstatutory !== null
    && (isstatutory ? statutorytypeid !== null : true);

  async onSave(name) {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    console.log('name: ', name);
    const { postdata } = this.state;
    console.log('postdata: ', postdata);
    const { getallsalarycomponents } = this.props;
    postdata.componentname = postdata.componentname.trim();
    if (postdata && !postdata.salarycomponentid) {
      if (!this.isvalid(postdata)) {
        this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
        return;
      } else if (postdata.isvariable && postdata.isaccrual) {
        this.props.enqueueSnackbar(ErrorMessages.E1430, { variant: "error" });
        return;
      }

      const data1 = { ...postdata };
      data1.issimplecomponent = postdata.mastercomponentid ? true : false;
      try {
        if (!postdata.salarycomponentid) {
          // const uniqueres = await instance.post("payroll/uniquecomponentname", { salarycomponentid: null, componentname: postdata.componentname });
          if (!issaveinprogress) {
            this.props.setSaveProgress(true);
            instance
              .post("payroll/uniquecomponentname", {
                salarycomponentid: null,
                componentname: postdata.componentname,
              })
              .then((uniqueres) => {
                this.props.removeSaveProgress();
                if (get(uniqueres, "data.result[0].isunique", "")) {
                  instance
                    .post("payroll/createsalarycomponent", data1)
                    .then(() => {
                      this.props.enqueueSnackbar(ErrorMessages.E0000, {
                        variant: "success",
                      });
                      this.props.closeDrawer();
                      getallsalarycomponents();
                    })
                    .catch((error) => {
                      this.props.enqueueSnackbar(
                        error.response
                          ? error.response.data.error.message
                          : error.message,
                        { variant: "error" },
                      );
                    });
                }
              })
              .catch((error) => {
                this.props.removeSaveProgress();
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              });
          }
        }
      } catch (error) {
        console.log("error: ", error);
      }
    } else if (postdata.salarycomponentid) {
      if (name == "name") {
        if (postdata.componentname) {
          const data = {
            "salarycomponentid": postdata.salarycomponentid,
            "componentname": postdata.componentname,
            "journalvoucher": postdata.journalvoucher,
          };
          console.log('data: ', data);
          if (!issaveinprogress) {
            this.props.setSaveProgress(true);
            instance
              .post("payroll/updatecomponent", data)
              .then(() => {
                this.props.removeSaveProgress();
                this.props.enqueueSnackbar(ErrorMessages.E0000, {
                  variant: "success",
                });
                this.props.closeDrawer();
                getallsalarycomponents();
              })
              .catch((error) => {
                this.props.removeSaveProgress();
                this.props.enqueueSnackbar(
                  error.response
                    ? error.response.data.error.message
                    : error.message,
                  { variant: "error" },
                );
              });
          }
        } else {
          this.props.enqueueSnackbar(
            "Please enter component name",
            { variant: "error" },
          );
        }
      } else if (name != "name") {
        if (!issaveinprogress) {
          this.props.setSaveProgress(true);
          instance
            .post("payroll/createsalarycomponent", postdata)
            .then(() => {
              this.props.removeSaveProgress();
              this.props.enqueueSnackbar(ErrorMessages.E0000, {
                variant: "success",
              });
              this.props.closeDrawer();
              getallsalarycomponents();
            })
            .catch((error) => {
              this.props.removeSaveProgress();
              this.props.enqueueSnackbar(
                error.response
                  ? error.response.data.error.message
                  : error.message,
                { variant: "error" },
              );
            });
        }
      }
    }
  }

  render() {
    const {
      postdata,
      allmastertaxgroup,
      issimplecomponentchecked,
    } = this.state;
    const {
      salarycomponentid,
      componentname,
      mastercomponentid,
      issimplecomponent,
      journalvoucher,
      isvariable,
      componenttypeid,
      isemployeededuction,
      paidastypeid,
      istaxfree,
      taxgroupheadid,
      mastertaxgroupid,
      isaccrual,
      isstatutory,
      statutorytypeid,
      isextrapayment,
      isextradeduction,
      // displayvalue,
    } = postdata;
    const {
      selectedsalarycomponent,
      closeDrawer,
      allmastercomponents,
      editname,
    } = this.props;
    return (
      <div className="height100">
        <div className="drawer-bg">
          <DrawerHeader
            header={
              selectedsalarycomponent
                ? get(selectedsalarycomponent, "name", "")
                : "Create new component"
            }
            closeDrawer={() => closeDrawer()}
          />
          {!editname
            ? <div>
              <div className="search-component">
                {!salarycomponentid && (
                  <DynamicForm
                    fields={checkboxinputconverter({
                      value: issimplecomponentchecked,
                      label: "Use readymade salary components",
                      disabled: salarycomponentid,
                    })}
                    onChange={(val) =>
                      this.setState({
                        issimplecomponentchecked: val,
                        postdata: !val
                          ? {
                            ...this.state.originalpostdata,
                            componentname: this.state.postdata.componentname,
                          }
                          : this.state.postdata,
                      })
                    }
                  />
                )}
                {issimplecomponentchecked && (
                  <DynamicForm
                    fields={selectinputconverter({
                      value: mastercomponentid,
                      options: allmastercomponents,
                      label: "Select component",
                      disabled: !issimplecomponentchecked,
                    })}
                    onChange={(val) => {
                      const data = allmastercomponents.find(
                        (x) => x.displayvalue == val,
                      );
                      if (data) {
                        this.setState({
                          postdata: {
                            ...this.state.postdata,
                            ...data,
                            mastercomponentid: val,
                            componentname: "",
                            // componentname: data.displayname,
                          },
                        });
                      } else {
                        this.setState({
                          postdata: {
                            ...POSTDATA,
                          },
                        });
                      }
                    }}
                  />
                )}
                <div className="margin-top-8">
                  <DynamicForm
                    className="width100"
                    fields={textinputconverter({
                      value: this.state.postdata.componentname,
                      placeholder: "Name this component",
                      label: "Component name",
                    })}
                    onChange={(val) => this.setpostdata("componentname", val)}
                  />
                </div>
              </div>
              {mastercomponentid || componentname || get(this.state, "postdata.displayvalue", "") ? (
                <div className="">
                  <div className="salary-component-details" style={{ overflowY: "unset", overflowX: "unset" }}>
                    <Paper className="padding8 margin-bottom-8">
                      <DynamicForm
                        className="width100"
                        fields={radioinputconverter({
                          value: componenttypeid == 1,
                          label: "Income",
                        })}
                        onChange={() => this.setState({
                          postdata: {
                            ...this.state.postdata,
                            componenttypeid: 1,
                            isextradeduction: false,
                            // istaxfree: null,
                            // taxgroupheadid: null,
                            // mastertaxgroupid: null,
                          },
                        })}
                      />
                      {componenttypeid == 1 && (
                        <div className="seleted-component-details-form">
                          <DynamicForm
                            className="width100"
                            fields={radioinputconverter({
                              value: paidastypeid == 3,
                              label: "Non-CTC",
                            })}
                            onChange={() =>
                              this.setpostdata(
                                "paidastypeid",
                                paidastypeid == 3 ? null : 3,
                              )
                            }
                          />
                          <DynamicForm
                            className="width100"
                            fields={radioinputconverter({
                              value: paidastypeid == 2,
                              label: "CTC",
                            })}
                            onChange={() =>
                              this.setpostdata(
                                "paidastypeid",
                                paidastypeid == 2 ? null : 2,
                              )
                            }
                          />
                          {/* <DynamicForm
                          className="width100"
                          fields={radioinputconverter({
                            value: paidastypeid == 1,
                            label: "Gross",
                          })}
                          onChange={() =>
                            this.setpostdata(
                              "paidastypeid",
                              paidastypeid == 1 ? null : 1,
                            )
                          }
                        /> */}
                        </div>
                      )}
                      <DynamicForm
                        className="width100"
                        fields={radioinputconverter({
                          value: componenttypeid == 2,
                          label: "Employee Deduction",
                        })}
                        onChange={() => {
                          this.setState({
                            postdata: {
                              ...this.state.postdata,
                              isemployeededuction: true,
                              componenttypeid: 2,
                              paidastypeid: 1,
                              isaccrual: false,
                              isextrapayment: false,
                              istaxfree: null,
                              taxgroupheadid: null,
                              mastertaxgroupid: null,
                            },
                          });
                        }}
                      />
                      {componenttypeid == 2 && (
                        <SectionHeaderExtraSmall header="Note: Employee deduction is from gross" />
                      )}

                      <DynamicForm
                        className="width100 margin-top-10"
                        fields={radioinputconverter({
                          value: componenttypeid == 3,
                          label: "Employer Deduction",
                        })}
                        onChange={() => {
                          this.setState({
                            postdata: {
                              ...this.state.postdata,
                              isemployeededuction: false,
                              componenttypeid: 3,
                              paidastypeid: null,
                              isaccrual: false,
                              isextrapayment: false,
                              istaxfree: null,
                              taxgroupheadid: null,
                              mastertaxgroupid: null,
                            },
                          });
                        }}
                      />

                      {componenttypeid == 3 && (
                        <div className="seleted-component-details-form">
                          <DynamicForm
                            className="width100"
                            fields={radioinputconverter({
                              value: paidastypeid == 3,
                              label: "Non-CTC",
                            })}
                            onChange={() =>
                              this.setpostdata(
                                "paidastypeid",
                                paidastypeid == 3 ? null : 3,
                              )
                            }
                          />
                          <DynamicForm
                            className="width100"
                            fields={radioinputconverter({
                              value: paidastypeid == 2,
                              label: "CTC",
                            })}
                            onChange={() =>
                              this.setpostdata(
                                "paidastypeid",
                                paidastypeid == 2 ? null : 2,
                              )
                            }
                          />
                        </div>
                      )}
                    </Paper>
                    {((componenttypeid && paidastypeid)
                      || isemployeededuction !== null) && (
                        <div>
                          {componenttypeid == 1 && (
                            <Paper className="padding8 margin-bottom-8 rectangle-paper">
                              <p className="extra-small-dark-secondary t-bold">
                                Is this variable?
                          </p>
                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: isvariable == true,
                                    label: "Yes",
                                  })}
                                  onChange={() =>
                                    this.setpostdata("isvariable", true)
                                  }
                                />
                              </span>
                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: isvariable == false,
                                    label: "No",
                                  })}
                                  onChange={() =>
                                    this.setpostdata("isvariable", false)
                                  }
                                />
                              </span>
                            </Paper>
                          )}
                          {componenttypeid == 1 && (
                            <Paper className="padding8 margin-bottom-8 rectangle-paper">
                              <p className="extra-small-dark-secondary t-bold">
                                Do you want to use this component to pay extra
                                payment?
                          </p>
                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: isextrapayment == true,
                                    label: "Yes",
                                  })}
                                  onChange={() =>
                                    this.setpostdata("isextrapayment", true)
                                  }
                                />
                              </span>
                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: isextrapayment == false,
                                    label: "No",
                                  })}
                                  onChange={() =>
                                    this.setpostdata("isextrapayment", false)
                                  }
                                />
                              </span>
                            </Paper>
                          )}
                          {componenttypeid && componenttypeid != 1 && (
                            <Paper className="padding8 margin-bottom-8 rectangle-paper">
                              <p className="extra-small-dark-secondary t-bold">
                                Do you want to use this component to recover extra
                                deduction?
                          </p>
                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: isextradeduction == true,
                                    label: "Yes",
                                  })}
                                  onChange={() =>
                                    this.setpostdata("isextradeduction", true)
                                  }
                                />
                              </span>
                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: isextradeduction == false,
                                    label: "No",
                                  })}
                                  onChange={() =>
                                    this.setpostdata("isextradeduction", false)
                                  }
                                />
                              </span>
                            </Paper>
                          )}
                          {componenttypeid && (componenttypeid == 1 || componenttypeid == 2)
                            && <Paper className="padding8 margin-bottom-8 rectangle-paper">
                              <p className="extra-small-dark-secondary t-bold">
                                Is this taxable component?
                        </p>
                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: istaxfree == true,
                                    label: "Yes",
                                  })}
                                  onChange={() =>
                                    this.setState({
                                      postdata: {
                                        ...this.state.postdata,
                                        istaxfree: true,
                                        taxgroupheadid: null,
                                        mastertaxgroupid: null,
                                        mastertaxgroupname: null,
                                        taxgroupheadname: null,
                                      },
                                    })
                                  }
                                />
                              </span>
                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: istaxfree == false,
                                    label: "No",
                                  })}
                                  onChange={() => this.setpostdata("istaxfree", false)}
                                />
                              </span>
                              {istaxfree == false && (
                                <DynamicForm
                                  fields={selectinputconverter({
                                    value: taxgroupheadid,
                                   options: (isextradeduction == true || isextrapayment == true) ? allmastertaxgroup.filter((item) => item.displayvalue == 99) : allmastertaxgroup,
                                    placeholder: "Select tax group",
                                    label: "Select tax group",
                                  })}
                                  onChange={(val) => {
                                    let tempid = allmastertaxgroup.find(
                                      (x) => x.displayvalue == val,
                                    );
                                    tempid = tempid ? tempid.mastertaxgroupid : null;
                                    this.setState({
                                      postdata: {
                                        ...this.state.postdata,
                                        taxgroupheadid: val,
                                        mastertaxgroupid: tempid,
                                      },
                                    });

                                    // this.setpostdata("taxgroupheadid", val) // taxgroupheadid: displayvalue, 2. mastertaxgroupid: 2. mastertaxgroupid,
                                  }}
                                />
                              )}
                            </Paper>}
                          {istaxfree !== null && (
                            <div>
                              {componenttypeid == 1 && (
                                <Paper className="padding8 margin-bottom-8 rectangle-paper">
                                  <p className="extra-small-dark-secondary t-bold">
                                    Will this component accrue?
                              </p>
                                  <DynamicForm
                                    className="width100"
                                    fields={radioinputconverter({
                                      value: isaccrual == true,
                                      label:
                                        "Yes, this component will accrue and will be paid after some time",
                                    })}
                                    onChange={() =>
                                      this.setpostdata("isaccrual", true)
                                    }
                                  />
                                  <div className="bg-light-blue margin-bottom-16 padding8">
                                    <p className="text-copy">
                                      You will have to set the frequency of payment &
                                      use of approval workflow for this component in
                                  salary structure.{" "}
                                    </p>
                                  </div>
                                  <DynamicForm
                                    className="width100"
                                    fields={radioinputconverter({
                                      value: isaccrual == false,
                                      label:
                                        "No, this component will not accrue and will be paid immediately when due",
                                    })}
                                    onChange={() =>
                                      this.setpostdata("isaccrual", false)
                                    }
                                  />
                                </Paper>
                              )}
                              {/* {isaccrual !== null && (
                            <Paper className="padding8 rectangle-paper">
                              <p className="extra-small-dark-secondary t-bold">
                                Is this statutory or non-statutory component?
                              </p>

                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: isstatutory == true,
                                    label: "Yes",
                                  })}
                                  onChange={() =>
                                    this.setpostdata("isstatutory", true)
                                  }
                                />
                              </span>

                              <span className="floatleft width50">
                                <DynamicForm
                                  className="width100"
                                  fields={radioinputconverter({
                                    value: isstatutory == false,
                                    label: "No",
                                  })}
                                  onChange={() =>
                                    this.setpostdata("isstatutory", false)
                                  }
                                />
                              </span>

                              {isstatutory == true && (
                                <div className="seleted-component-details-form">
                                  <DynamicForm
                                    className="width100"
                                    fields={radioinputconverter({
                                      value: statutorytypeid == 1,
                                      label: "Basic Pay",
                                    })}
                                    onChange={() =>
                                      this.setpostdata(
                                        "statutorytypeid",
                                        statutorytypeid == 1 ? null : 1,
                                      )
                                    }
                                  />
                                  <DynamicForm
                                    className="width100"
                                    fields={radioinputconverter({
                                      value: statutorytypeid == 2,
                                      label: "Bonus",
                                    })}
                                    onChange={() =>
                                      this.setpostdata(
                                        "statutorytypeid",
                                        statutorytypeid == 2 ? null : 2,
                                      )
                                    }
                                  />
                                  <DynamicForm
                                    className="width100"
                                    fields={radioinputconverter({
                                      value: statutorytypeid == 7,
                                      label: "Gratuity",
                                    })}
                                    onChange={() =>
                                      this.setpostdata(
                                        "statutorytypeid",
                                        statutorytypeid == 3 ? null : 3,
                                      )
                                    }
                                  />
                                </div>
                              )}
                            </Paper>
                          )} */}
                            </div>
                          )}
                        </div>
                      )}
                    {(isstatutory == false
                      || (isstatutory == true && statutorytypeid)) && (
                        <Paper className="padding8 margin-bottom-8 margin-top-8 rectangle-paper">
                          {/* <DynamicForm
                            fields={textinputconverter({
                              value: journalvoucher,
                              label: "Journal voucher1 (Optional)",
                            })}
                            onChange={(val) =>
                              this.setpostdata("journalvoucher", val)
                            }
                          /> */}
                          <p className="input-label">Journal voucher (Optional)"</p>
                          <TextField
                id="outlined-dense"
                className="width100"
              
                variant="outlined"
                placeholder=""
                // onChange={(val) =>
                //   this.setpostdata("journalvoucher", val)
                // }
                onChange={(e) => this.setpostdata("journalvoucher", e.target.value)}
                value={journalvoucher}
              
              />
                        </Paper>
                      )}
                  </div>

                  <div className="text-center margin-top-20 margin-bottom-40">
                    {this.isvalid(postdata) && (
                      <Button
                        className="btn btn-primary-sm-blue"
                        variant="contained"
                        onClick={this.onSave}
                        disabled={this.props.SaveInProgressReducer.issaveinprogress}
                      >
                        {salarycomponentid
                          ? "Update"
                          : issimplecomponent
                            ? "Create component"
                            : "Create custom component"}
                      </Button>
                    )}
                  </div>
                </div>
              ) : (
                  <div className="empty-state">
                    <div className="empty-state-details">
                      <img src={emptySearch}></img>
                      <p>Start by searching a salary component</p>
                    </div>
                  </div>
                )}
            </div>
            : <div>
              <div className="margin-top-8">
                <DynamicForm
                  className="width100"
                  fields={textinputconverter({
                    value: this.state.postdata.componentname,
                    placeholder: "Name this component",
                    label: "Component name",
                  })}
                  onChange={(val) => this.setpostdata("componentname", val)}
                />
              </div>
              <DynamicForm
                fields={textinputconverter({
                  value: journalvoucher,
                  label: "Journal voucher (Optional)",
                })}
                onChange={(val) =>
                  this.setpostdata("journalvoucher", val)
                }
              />
              <Button
                className="btn btn-primary-sm-blue"
                variant="contained"
                onClick={() => this.onSave("name")}
                disabled={this.props.SaveInProgressReducer.issaveinprogress}
              >
                Update
            </Button>
            </div>
          }
        </div>
      </div>
    );
  }
}

const POSTDATA = {
  salarycomponentid: null, // 3
  componentname: null,
  mastercomponentid: null, // 11
  issimplecomponent: true, // true if from master, true, else false
  journalvoucher: null, // "12358" optional journal voucher textinput
  isvariable: false, // null was there // true
  isextrapayment: false,
  isextradeduction: false,

  // 1 ((componenttypeid && paidastypeid) || isemployeededuction !== null)
  componenttypeid: null, // 1
  isemployeededuction: null, // false
  paidastypeid: null, // 1, is it 1,2,3?

  // 2 (istaxfree !== null)
  istaxfree: null, // true
  taxgroupheadid: null, // 10
  mastertaxgroupid: null, // 1111

  // 3 (isaccrual !== null)
  isaccrual: null, // false

  // 4 (isstatutory !== null && statutorytypeid !== null)
  isstatutory: false, // true
  statutorytypeid: null, // 1
};

